import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { AbsenceItem, Absence } from '../models';

export class AbsenceApi extends ApiModule {
  protected endpoint = '/absence';

  public async pageAbsences(params: any) {
    return this.api.post<PaginatedResponseData<AbsenceItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadAbsenceDetails(id: number) {
    return this.api.get<Absence>(`${this.endpoint}?id=${id}`);
  }

  public saveAbsence(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteAbsence(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
}
